import { css } from "@linaria/core";

export const messageCls = css`
  --margin-left: min(55px, var(--white-space-size));

  position: absolute;
  top: calc(50% + 30px);
  left: calc(var(--margin-left) + 20px);
  transform: translateY(-50%);
  width: calc(100% - 40px - var(--margin-left) - var(--white-space-size));

  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;

  font-family: var(--font-family);
  font-size: calc(24 * var(--font-px));
  font-weight: 400;
  color: #262626;
  opacity: 0.5;
  text-align: center;
`;
